import Uploader from './Uploader';

// export types
export type { UploaderInstance, UploaderProps, FileStatusType, FileType } from './Uploader';

// export components
export { Uploader };
export default Uploader;
